"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var constants_1 = require("./constants");
var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "+";
    SortDirection["Descending"] = "-";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var Sort = /** @class */ (function () {
    function Sort(sortBy, sortOrder) {
        this.sortBy = sortBy;
        this.sortOrder = sortOrder;
    }
    return Sort;
}());
exports.Sort = Sort;
var QueryParams = /** @class */ (function () {
    function QueryParams(path) {
        var query = path.split('?')[1] || {};
        var params = qs_1.default.parse(query);
        var filtersParam = __assign({}, (params.filters || {}));
        var dateRangeFilter = filtersParam.date_range, filters = __rest(filtersParam, ["date_range"]);
        this.dateRange = this.parseDateRange(dateRangeFilter);
        this.filters = this.parseFilters(filters);
        this.mode = params.view_mode;
        this.page = parseInt(params.page) || 1;
        this.sort = this.parseSort(params.sort);
        this.pageSize = parseInt(params.page_size) || 20;
        this.query = params.query;
    }
    QueryParams.prototype.parseFilters = function (filters) {
        if (filters === void 0) { filters = {}; }
        var parsedFilters = Object.keys(filters).reduce(function (acc, facetId) {
            var _a;
            var filterIds = filters[facetId].split(',').filter(function (id) { return Boolean(id); });
            var reducedFilters = filterIds.length
                ? filterIds.reduce(function (filtersAcc, filterId) {
                    var _a;
                    return (__assign({}, filtersAcc, (_a = {}, _a[filterId] = filterId, _a)));
                }, {})
                : null;
            return reducedFilters
                ? __assign({}, acc, (_a = {}, _a[facetId] = reducedFilters, _a)) : acc;
        }, {});
        return parsedFilters;
    };
    QueryParams.prototype.parseDateRange = function (dates) {
        if (dates === void 0) { dates = ''; }
        var dateRange = dates.split(',');
        if (dateRange.length !== 2) {
            return [];
        }
        var firstDate = Date.parse(dateRange[0]);
        var secondDate = Date.parse(dateRange[1]);
        var areValid = !isNaN(firstDate) && !isNaN(secondDate);
        return areValid ? [new Date(firstDate), new Date(secondDate)] : [];
    };
    QueryParams.prototype.parseSort = function (sort) {
        if (typeof sort !== 'string') {
            return {};
        }
        var order = sort[0];
        var _a = Object.entries(SortDirection).find(function (_a) {
            var _ = _a[0], value = _a[1];
            return value === order;
        }), _ = _a[0], direction = _a[1];
        return direction ? new Sort(sort.slice(1), direction) : {};
    };
    return QueryParams;
}());
exports.QueryParams = QueryParams;
var QueryHelper = /** @class */ (function () {
    function QueryHelper() {
    }
    QueryHelper.parse = function (path) {
        return new QueryParams(path);
    };
    QueryHelper.stringify = function (params) {
        var q = qs_1.default.stringify(params);
        return q;
    };
    return QueryHelper;
}());
exports.QueryHelper = QueryHelper;
var default_1 = /** @class */ (function () {
    function default_1() {
        var _a;
        this.namespaced = true;
        this.state = {
            errorLoading: false,
            orgId: '',
            isFiltering: false,
            isLoading: false,
            isPaginating: false,
            isSearching: false,
            isSorting: false,
            // collection state
            appliedFilters: {},
            data: [],
            dateRange: [],
            dateRangePreset: {},
            defaultDateRange: [],
            facets: [],
            mode: undefined,
            page: 1,
            pageCount: 0,
            pageSize: 20,
            query: undefined,
            sort: {},
            defaultSortBy: undefined,
            defaultSortOrder: undefined,
            summary: {},
            total: 0
        };
        this.getters = {
            orgId: function (state) { return state.orgId; },
            isLoading: function (state) { return state.isLoading; },
            isEmpty: function (state) { return state.data.length === 0; },
            isFiltering: function (state) { return state.isFiltering; },
            isPaginating: function (state) { return state.isPaginating; },
            isSearching: function (state) { return state.isSearching; },
            isSorting: function (state) { return state.isSorting; },
            errorLoading: function (state) { return state.errorLoading; },
            data: function (state) { return state.data; },
            facets: function (state) { return state.facets; },
            dateRange: function (state) { return state.dateRange; },
            dateRangePreset: function (state) { return state.dateRangePreset; },
            defaultDateRange: function (state) { return state.defaultDateRange; },
            isDefaultDateRangeApplied: function (state) {
                if (state.defaultDateRange.length === 0 && state.dateRange.length === 0) {
                    return true;
                }
                if (state.defaultDateRange.length !== state.dateRange.length) {
                    return false;
                }
                var firstDefaultDateRange = state.defaultDateRange[0]
                    ? new Date(state.defaultDateRange[0]).setHours(0, 0, 0, 0)
                    : null;
                var firstDateRange = state.dateRange[0] ? new Date(state.dateRange[0]).setHours(0, 0, 0, 0) : null;
                var secondDefaultDateRange = state.defaultDateRange[1]
                    ? new Date(state.defaultDateRange[1]).setHours(0, 0, 0, 0)
                    : null;
                var secondDateRange = state.dateRange[1] ? new Date(state.dateRange[1]).setHours(0, 0, 0, 0) : null;
                var isFirstEqual = firstDefaultDateRange == firstDateRange;
                var isSecondEqual = secondDefaultDateRange == secondDateRange;
                return isFirstEqual && isSecondEqual;
            },
            summary: function (state) { return state.summary; },
            appliedFilters: function (state) { return state.appliedFilters; },
            mode: function (state) { return state.mode; },
            page: function (state) { return state.page; },
            pageCount: function (state) { return state.pageCount; },
            pageSize: function (state) { return state.pageSize; },
            total: function (state) { return state.total; },
            query: function (state) { return state.query; },
            sort: function (state) { return state.sort; },
            sortBy: function (state) { return state.sort.sortBy || state.defaultSortBy; },
            sortOrder: function (state) { return state.sort.sortOrder || state.defaultSortOrder; },
            sortQueryParam: function (state, getters) {
                var sortOrder = getters.sortOrder || '';
                var sortBy = getters.sortBy || '';
                return "" + sortOrder + sortBy || undefined;
            },
            dateRangeParam: function (state) {
                var dateRange = state.dateRange;
                return dateRange[0] && dateRange[1]
                    ? { date_range: dateRange[0].toISOString() + "," + dateRange[1].toISOString() }
                    : {};
            },
            filtersParam: function (state, getters) {
                var filtersParam = Object.keys(state.appliedFilters).reduce(function (acc, key) {
                    var _a;
                    return (__assign({}, acc, (_a = {}, _a[key] = Object.keys(state.appliedFilters[key]).join(','), _a)));
                }, {});
                return __assign({}, getters.dateRangeParam, filtersParam);
            },
            facetQueryParams: function (state, getters) {
                return { filters: __assign({}, getters.filtersParam) };
            },
            urlQueryParams: function (state, getters) { return ({
                filters: getters.filtersParam,
                view_mode: state.mode,
                page: state.page,
                page_size: state.pageSize,
                sort: getters.sortQueryParam,
                query: state.query
            }); },
            urlQueryString: function (state, getters) { return QueryHelper.stringify(getters.urlQueryParams); }
        };
        this.actions = {
            applyFilters: function (_a, _b) {
                var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
                var _c = _b === void 0 ? {} : _b, _d = _c.dateRange, dateRange = _d === void 0 ? null : _d, _e = _c.dateRangePreset, dateRangePreset = _e === void 0 ? {} : _e, _f = _c.filters, filters = _f === void 0 ? {} : _f;
                dateRange = dateRange ? dateRange : getters.defaultDateRange;
                commit(constants_1.FILTER_BASE_COLLECTION_PENDING, { dateRange: dateRange, dateRangePreset: dateRangePreset, filters: filters, isEmpty: getters.isEmpty });
                dispatch('goToRoute');
                return dispatch('load').then(function () {
                    commit(constants_1.FILTER_BASE_COLLECTION_SUCCESS);
                });
            },
            resetAllFilters: function (_a) {
                var dispatch = _a.dispatch;
                return dispatch('applyFilters');
            },
            clearQuery: function (_a) {
                var dispatch = _a.dispatch;
                return dispatch('search');
            },
            clearSort: function (_a) {
                var dispatch = _a.dispatch, getters = _a.getters;
                var sort = Boolean(getters.defaultSortBy && getters.defaultSortOrder)
                    ? { sortBy: getters.defaultSortBy, sortOrder: getters.defaultSortOrder }
                    : {};
                return dispatch('sort', sort);
            },
            get: function (_a) {
                var commit = _a.commit, dispatch = _a.dispatch;
                commit(constants_1.GET_BASE_COLLECTION_PENDING);
                return dispatch('load');
            },
            load: function () {
                throw new Error('You have not defined a `load` action in your vuex module.');
            },
            next: function (_a) {
                var dispatch = _a.dispatch, getters = _a.getters;
                var page = getters.page + 1;
                return dispatch('setPage', page);
            },
            previous: function (_a) {
                var dispatch = _a.dispatch, getters = _a.getters;
                var page = getters.page - 1;
                return dispatch('setPage', page);
            },
            search: function (_a, query) {
                var commit = _a.commit, dispatch = _a.dispatch;
                commit(constants_1.SEARCH_BASE_COLLECTION_PENDING, query);
                dispatch('goToRoute');
                return dispatch('load').then(function () {
                    commit(constants_1.SEARCH_BASE_COLLECTION_SUCCESS);
                });
            },
            setMode: function (_a, mode) {
                var commit = _a.commit, dispatch = _a.dispatch;
                commit(constants_1.UPDATE_BASE_COLLECTION_MODE, mode);
                return dispatch('setPage', 1);
            },
            setPage: function (_a, page) {
                var commit = _a.commit, dispatch = _a.dispatch;
                commit(constants_1.PAGINATE_BASE_COLLECTION_PENDING, page);
                dispatch('goToRoute');
                return dispatch('load').then(function () {
                    commit(constants_1.PAGINATE_BASE_COLLECTION_SUCCESS);
                });
            },
            setup: function (_a, _b) {
                var commit = _a.commit;
                var path = _b.path, orgId = _b.orgId;
                commit(constants_1.SETUP_BASE_COLLECTION, { path: path, orgId: orgId });
            },
            sort: function (_a, sort) {
                var commit = _a.commit, dispatch = _a.dispatch;
                commit(constants_1.SORT_BASE_COLLECTION_PENDING, sort);
                dispatch('goToRoute');
                return dispatch('load').then(function () {
                    commit(constants_1.SORT_BASE_COLLECTION_SUCCESS);
                });
            }
        };
        this.mutations = (_a = {},
            _a[constants_1.GET_BASE_COLLECTION_PENDING] = function (state) {
                state.isLoading = true;
                state.errorLoading = false;
            },
            _a[constants_1.GET_BASE_COLLECTION_ERROR] = function (state) {
                state.isLoading = false;
                state.errorLoading = true;
            },
            _a[constants_1.GET_BASE_COLLECTION_SUCCESS] = function (state, data) {
                state.isLoading = false;
                state.data = data.data.rows;
                state.facets = data.data.facets;
                state.summary = data.data.summary;
                state.pageCount = data.total_pages;
                state.total = data.total_records;
            },
            _a[constants_1.PAGINATE_BASE_COLLECTION_PENDING] = function (state, page) {
                state.page = page;
                state.isPaginating = true;
            },
            _a[constants_1.PAGINATE_BASE_COLLECTION_SUCCESS] = function (state) {
                state.isPaginating = false;
            },
            _a[constants_1.SORT_BASE_COLLECTION_PENDING] = function (state, sort) {
                // always reset page when sorting
                state.page = 1;
                state.sort = sort;
                state.isSorting = true;
            },
            _a[constants_1.SORT_BASE_COLLECTION_SUCCESS] = function (state) {
                state.isSorting = false;
            },
            _a[constants_1.SETUP_BASE_COLLECTION] = function (state, _a) {
                var path = _a.path, orgId = _a.orgId;
                var queryParams = QueryHelper.parse(path);
                state.orgId = orgId;
                state.appliedFilters = queryParams.filters;
                state.dateRange = queryParams.dateRange.length === 0 ? state.defaultDateRange : queryParams.dateRange;
                state.page = queryParams.page;
                state.pageSize = queryParams.pageSize;
                state.sort = queryParams.sort;
                state.query = queryParams.query;
                state.mode = queryParams.mode;
            },
            _a[constants_1.FILTER_BASE_COLLECTION_PENDING] = function (state, _a) {
                var dateRange = _a.dateRange, dateRangePreset = _a.dateRangePreset, filters = _a.filters, isEmpty = _a.isEmpty;
                state.appliedFilters = __assign({}, filters);
                state.dateRange = dateRange.slice();
                state.dateRangePreset = __assign({}, dateRangePreset);
                if (isEmpty) {
                    state.isLoading = true;
                }
                else {
                    state.isFiltering = true;
                }
            },
            _a[constants_1.FILTER_BASE_COLLECTION_SUCCESS] = function (state) {
                state.isFiltering = false;
            },
            _a[constants_1.UPDATE_BASE_COLLECTION_MODE] = function (state, mode) {
                state.mode = mode;
            },
            _a[constants_1.SEARCH_BASE_COLLECTION_PENDING] = function (state, query) {
                state.query = query;
                state.isSearching = true;
            },
            _a[constants_1.SEARCH_BASE_COLLECTION_SUCCESS] = function (state) {
                state.isSearching = false;
            },
            _a);
    }
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=base_collection_store.js.map